import api from './api';
import { Service } from './servicesService';

export interface Clinic {
  id: number;
  name: string;
  id_prefix: string;
  timezone: string;
  language: string;
  default_country_code: string;
  state: string | null;
  sms_sender: string | null;
  email_sender: string | null;
  email_sender_name: string | null;
  email_footer: string | null;
  sms_footer: string | null;
  clinic_contact_info_email: string | null;
  clinic_contact_info_sms: string | null;
  logo: string | null;
  service_id: number | null;
  service?: Service | null;
  tenant_id: number;
  created_at: string;
  updated_at: string;
}

export interface ClinicCreate {
  name: string;
  id_prefix: string;
  timezone?: string;
  language?: string;
  default_country_code?: string;
  state?: string;
  sms_sender?: string;
  email_sender?: string;
  email_sender_name?: string;
  email_footer?: string | null;
  sms_footer?: string | null;
  clinic_contact_info_email?: string | null;
  clinic_contact_info_sms?: string | null;
  logo?: string;
  service_id?: number | null;
  tenant_id?: number;
}

export interface ClinicUpdate {
  name?: string;
  id_prefix?: string;
  timezone?: string;
  language?: string;
  default_country_code?: string;
  state?: string;
  sms_sender?: string;
  email_sender?: string;
  email_sender_name?: string;
  email_footer?: string | null;
  sms_footer?: string | null;
  clinic_contact_info_email?: string | null;
  clinic_contact_info_sms?: string | null;
  logo?: string;
  service_id?: number | null;
}

export const clinicService = {
  async getClinics(tenantId?: number): Promise<Clinic[]> {
    const params = tenantId ? `?tenant_id=${tenantId}` : '';
    const response = await api.get(`/clinics/${params}`);
    return response.data;
  },

  async getClinic(clinicId: number): Promise<Clinic> {
    const response = await api.get(`/clinics/${clinicId}`);
    return response.data;
  },

  async createClinic(clinicData: ClinicCreate): Promise<Clinic> {
    const response = await api.post('/clinics/', clinicData);
    return response.data;
  },

  async updateClinic(clinicId: number, clinicData: ClinicUpdate): Promise<Clinic> {
    const response = await api.put(`/clinics/${clinicId}`, clinicData);
    return response.data;
  },

  async deleteClinic(clinicId: number): Promise<void> {
    await api.delete(`/clinics/${clinicId}`);
  },

  async uploadLogo(clinicId: number, file: File): Promise<{ s3_key: string }> {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post(`/clinics/${clinicId}/logo`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  async deleteLogo(clinicId: number): Promise<void> {
    await api.delete(`/clinics/${clinicId}/logo`);
  },

  getLogoUrl(clinicId: number): string {
    const baseUrl = (process.env.REACT_APP_API_URL || '').replace(/\/?$/, '');
    return `${baseUrl}/public/clinic-logo/${clinicId}`;
  },
};
